import React from 'react';

function DashedLine(props) {
  return (
    <svg {...props} width="100%" height="1" strokeWidth="1" strokeDasharray="17" viewBox="0 0 2000 1" xmlns="http://www.w3.org/2000/svg">
      <line x1="0" y1="0" x2="2001" y2="0" stroke="currentColor" fillRule="evenodd" />
    </svg>
  );
}

export default DashedLine;
